import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=81db22fc&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./../../public/static/scss/HyperblockView.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Home.vue?vue&type=style&index=1&id=81db22fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81db22fc",
  null
  
)

export default component.exports